import React, { lazy, Suspense, useState, createContext, useContext } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

// ROI Context
export const ROIContext = createContext();
export const useROI = () => useContext(ROIContext);

const Navbar = lazy(() => import('./components/Navbar'));
const HeroSection = lazy(() => import('./components/HeroSection'));
const ThesisSection = lazy(() => import('./components/ThesisSection'));
const ParcelsSection = lazy(() => import('./components/ParcelsSection'));
const InfrastructureSection = lazy(() => import('./components/InfrastructureSection'));
const Footer = lazy(() => import('./components/Footer'));
const Dashboard = lazy(() => import('./components/Dashboard'));
const ROIEngine = lazy(() => import('./components/ROIEngine'));

const LoginWrapper = lazy(() =>
  import('./components/AuthPages').then((mod) => ({ default: mod.LoginPage }))
);
const SignupWrapper = lazy(() =>
  import('./components/AuthPages').then((mod) => ({ default: mod.SignupPage }))
);

const Loader = () => (
  <div className="flex items-center justify-center min-h-screen bg-[var(--cream)]">
    <div className="flex flex-col items-center gap-4">
      <img src="/velloracity-logo.png" alt="Dholera Greenfield" className="h-12 w-auto animate-pulse" />
      <p className="font-mono text-[11px] tracking-[0.15em] text-[var(--slate-dark)] uppercase">
        Loading Dholera Greenfield...
      </p>
    </div>
  </div>
);

const HomePage = () => (
  <>
    <HeroSection />
    <ThesisSection />
    <ParcelsSection />
    <InfrastructureSection />
    <Footer />
  </>
);

function App() {
  const [roiOpen, setRoiOpen] = useState(false);

  return (
    <ROIContext.Provider value={{ roiOpen, setRoiOpen }}>
      <div className="min-h-screen bg-[var(--cream)]">
        <BrowserRouter>
          <Suspense fallback={<Loader />}>
            <Navbar />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/login" element={<LoginWrapper />} />
              <Route path="/signup" element={<SignupWrapper />} />
              <Route path="/dashboard" element={<Dashboard />} />
            </Routes>
            <ROIEngine isOpen={roiOpen} onClose={() => setRoiOpen(false)} />
          </Suspense>
        </BrowserRouter>
      </div>
    </ROIContext.Provider>
  );
}

export default App;
